<div class="pr-large-y">
  <h1 class="font-heading-3 ms-clear bold-type {{ headingClass() }} font-headline-small">{{ title() }}</h1>
  @if (subtitle()) {
    <p class="font-body-1 nordic-blue-900-text text-icon-primary font-body-medium">{{ subtitle() }}</p>
  }
</div>
